import { useEffect, useState } from "react";

export const MOBILE_EDITOR_QUERY = "(max-width: 760px)";

const matchesEditorQuery = (query, fallbackMaxWidth) => {
    if (typeof window === "undefined") return false;
    return typeof window.matchMedia === "function"
        ? window.matchMedia(query).matches
        : window.innerWidth <= fallbackMaxWidth;
};

function useEditorViewportQuery(query, fallbackMaxWidth) {
    const [matchesQuery, setMatchesQuery] = useState(() => matchesEditorQuery(query, fallbackMaxWidth));

    useEffect(() => {
        if (typeof window.matchMedia !== "function") {
            const updateFromWidth = () => setMatchesQuery(window.innerWidth <= fallbackMaxWidth);
            window.addEventListener("resize", updateFromWidth);
            return () => window.removeEventListener("resize", updateFromWidth);
        }

        const mediaQuery = window.matchMedia(query);
        const updateFromMedia = event => setMatchesQuery(event.matches);
        setMatchesQuery(mediaQuery.matches);

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener("change", updateFromMedia);
            return () => mediaQuery.removeEventListener("change", updateFromMedia);
        }

        if (mediaQuery.addListener) {
            mediaQuery.addListener(updateFromMedia);
            return () => mediaQuery.removeListener(updateFromMedia);
        }

        const updateFromWidth = () => setMatchesQuery(window.innerWidth <= fallbackMaxWidth);
        window.addEventListener("resize", updateFromWidth);
        return () => window.removeEventListener("resize", updateFromWidth);
    }, [query, fallbackMaxWidth]);

    return matchesQuery;
}

function useMobileEditorViewport() {
    return useEditorViewportQuery(MOBILE_EDITOR_QUERY, 760);
}

export default useMobileEditorViewport;
